import randomColor from 'randomcolor';

export const getRandomColorBySeed = (
  seed: string,
  highlightCriteria?: () => boolean
): string | undefined =>
  highlightCriteria?.()
    ? randomColor({
        seed: seed,
        luminosity: 'bright',
        format: 'rgba',
        alpha: 0.5
      })
    : randomColor({
        seed: seed,
        luminosity: 'light',
        format: 'rgba',
        alpha: 0.15
      });
